import { Api } from 'core/api';
import localStorage from 'core/local-storage/localStorage';

import { extendQueryString } from './helpers';
import qs from 'qs';

const contentApi = new Api({
  namespace: 'GET_CONTENT',
  useEagleApi: true,
  url: '/internal-intranet/content',
  options: {
    method: 'POST',
  },
});

export const fetchContent = (id = 'default', { search, locale }: any) => {
  const adminParams = localStorage.get('admin-toolbar-settings');

  const additionalParams = {} as any;
  if (locale) {
    additionalParams.locale = locale;
  }

  if (adminParams) {
    additionalParams.adminParams = adminParams;
  }
  const searchQuery = qs.parse(search.replace(/^\?/, ''));
  const searchString = extendQueryString(search, additionalParams);
  return contentApi.fetch({
    urlParams: `/${id}${searchString}`,
    options: {
      body: JSON.stringify({
        page: Number(searchQuery.page) || 0,
        pageSize: Number(searchQuery.limit) || 10,
      }),
    },
  });
};

const oldContentApi = new Api({
  namespace: 'GET_CONTENT',
});
export const fetchOldContent = (id = 'default', { search, locale }: any) => {
  const adminParams = localStorage.get('admin-toolbar-settings');

  const additionalParams = {} as any;
  if (locale) {
    additionalParams.locale = locale;
  }

  if (adminParams) {
    additionalParams.adminParams = adminParams;
  }

  const searchString = extendQueryString(search, additionalParams);

  return oldContentApi.fetch({
    url: `/content/${id}${searchString}`,
  });
};
export const reducer = contentApi.reducer;
